import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {ApiResponseModel, ApiVisa, BaseApiTemplateService, Core2Config} from '../../shared';
import {Observable} from 'rxjs';
import { GenericDocLinkContainerModel } from '../../../../../../models/aggregates/generic_doc';


@Injectable({
  providedIn: 'root'
})
export class GenericDocLinkService extends BaseApiTemplateService<GenericDocLinkContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX +
  Core2Config.ERP_PREFIX + 'generic-doc/links';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'generic-doc/links';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'generic-doc/links';
    this.httpClient = http;
  }
}
